import React, { useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({
  rec,
  handleCancelClick,
  increment,
  setRecId,
  members,
  roles,
}) => {
  const [newRec, setNewRec] = useState(rec);
  const [error, setError] = useState(false);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();
  const handleDDSChange = (e) => {
    e.preventDefault();

    const n = Number(e.target.value);
    const name = e.target.name;

    setNewRec((prevState) => ({
      ...prevState,
      [name]: n,
    }));
  };

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    const { name, value } = e.target;
    setNewRec((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleChangeCheckBox = (e) => {
    e.preventDefault(); // prevent the default action
    const checkValue = e.target.checked;
    setNewRec((prevState) => ({
      ...prevState,
      attend: checkValue,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();

    const getData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "bhinamember/" + newRec.id + "/",
          newRec,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          alert("העדכון בוצע.");
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
    setRecId(null);
    setError(false);
  };

  return (
    <tr>
      <td></td>
      <td>
        <select
          name="memberlist"
          onChange={handleDDSChange}
          value={newRec.memberlist}
          style={{ width: "15ch" }}
        >
          <option value="" selected>
            בחר חבר
          </option>
          {members
            ?.filter((i) => i.active === true)
            .map((o) => (
              <option key={o.id} value={o.id}>
                {o.first_name + " " + o.last_name}
              </option>
            ))}
        </select>
      </td>
      <td>
        <select
          name="role"
          onChange={handleDDSChange}
          value={newRec.role}
          style={{ width: "15ch" }}
        >
          <option value="" selected>
            בחר תפקיד
          </option>
          {roles?.map((o) => (
            <option key={o.id} value={o.id}>
              {o.title}
            </option>
          ))}
        </select>
      </td>
      <td>
        <input
          type="date"
          name="send_date"
          className="form-control"
          id="send_date"
          value={newRec.send_date}
          onChange={handleChange}
        />
      </td>
      <td>
        <input
          type="checkbox"
          id="attend"
          name="attend"
          value={newRec.attend}
          onChange={handleChangeCheckBox}
          checked={newRec.attend}
        />
      </td>
      <td>
        <textarea
          cols={50}
          rows={2}
          name="notes"
          value={newRec.notes}
          onChange={handleChange}
          className="form-control"
          id="notes"
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          Save
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          Cancel
        </button>
      </td>
    </tr>
  );
};

export default Edit;
